var app = angular.module("leonardo");

var VendorCategoryList = function($scope, CategoryVendorService, ngDialog, AuthDataService, FilterService, $timeout) {
  $scope.categories = [];
  $scope.authDataService = AuthDataService;

  $scope.showCategoryDeleteDialog = function(category) {
    ngDialog.openConfirm({
      template: 'views/templates/dialog/delete.html',
      controller: 'DeleteDialog',
      data: {
        object: category,
        type: 'vendor category'
      }
    }).then(function(data){
      CategoryVendorService.updateCollection(data, true);
      $scope.refresh();
    }, function () {
      return;
    });
  };

  $scope.showCategoryEditDialog = function(category) {
     ngDialog.open({
      template: 'views/templates/dialog/vendor/category-add.html',
      controller: 'VendorCategoryAddDialog',
      data: {
        category: category,
        mode: 'edit'
      }
    });
  };

  $scope.getParams = function() {
    var filters = {disable_pagination: true};
    if (FilterService.hasFilter('vendor_category_name')) {
      filters['name'] = FilterService.getFilter('vendor_category_name');
    }
    return filters;
  };

  $scope.refresh = function() {
    CategoryVendorService.getlist($scope.getParams()).then(function(data) {
      $scope.categories = data;
    });
  };

  $scope.$on('vendor-category:added', $scope.refresh);

  $scope.$on('filter-selection:updated', $scope.refresh);

  $timeout(function () {
    $scope.refresh();
  }, 0);

};

app.controller('VendorCategoryList', ['$scope', 'CategoryVendorService', 'ngDialog', 'AuthDataService', 'FilterService',
  '$timeout', VendorCategoryList]);
